// Global Instructions Rule Applied!
//
// Configuration → Fund Statuses admin model: one cfg.fund_statuses row plus
// usage_count (live funds referencing it from EITHER column) — what the delete
// guard counts (usage > 0 forces the Replace flow).
// Shape mirrors public.view__fund_statuses.
//
// The three flags are the whole point of the catalogue: every consumer — the
// prospect-follower gate, the app-wide picker defaults, the Tag colours —
// reads THEM, never the name or the value. cfg.pipeline_statuses lets the
// frontend match on 'fundraising_status_060'; that is legacy and is exactly
// the hardcoded-lookup-value smell CLAUDE.md forbids, so it is not repeated
// here.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const FUND_STATUS_CATEGORIES = ['fundraising', 'investment'] as const

export type FundStatusCategory = (typeof FUND_STATUS_CATEGORIES)[number]

export const FUND_STATUS_CATEGORY_LABELS: Record<FundStatusCategory, string> = {
  fundraising: 'Fundraising',
  investment: 'Investment'
}

export const FundStatusAdminRowSchema = z
  .object({
    fund_statuses__id: z.string(),
    fund_statuses__name: z.string(),
    fund_statuses__category: z.string(),
    fund_statuses__value: z.string().nullish(),
    fund_statuses__sort_order: z.number().nullish(),
    fund_statuses__is_open: z.boolean(),
    fund_statuses__is_cancelled: z.boolean(),
    fund_statuses__is_terminal: z.boolean(),
    fund_statuses__usage_count: z.number(),
    fund_statuses__date_modified: z.string().nullish()
  })
  .strict()

export type FundStatusAdminRow = z.infer<typeof FundStatusAdminRowSchema>

export function validateFundStatusAdminRow(
  data: unknown,
  options?: { isArray?: boolean }
): FundStatusAdminRow | FundStatusAdminRow[] {
  try {
    return validateWithZodSchema(
      FundStatusAdminRowSchema,
      data,
      'fund status admin row',
      options
    ) as FundStatusAdminRow | FundStatusAdminRow[]
  } catch (e) {
    throw new Error(`Fund status validation failed: ${e}`)
  }
}
